<template>
  <v-content padding=0 class="siteContent">
    <v-container fluid pa-0>
      <router-view/>
    </v-container>
  </v-content>
</template>

<script>
import { components } from 'aws-amplify-vue'

export default {
  name: 'siteContent',
  components: {
    ...components
  }
}
</script>
<style>
  .siteContent {
    padding-bottom: 50px!important;
    background-color: orange!important;
  }
</style>
